import { withNavigationWatcher } from './contexts/navigation';
import { HomePage, PreferredRoute, LoadConfirmation, FuelPlan, Reconcile, StopDetails,ExpenseApproval, TestPushNotifications  } from './pages';
import { CreateExpense } from './components/CreateExpenseComponent'
import { Logout } from './components/okta';
import { DemoLoad } from './components/load-confirmation';


const routes = [
    {
        path: '/home',
        component: HomePage,
        title: 'DTI Driver'
    },
    //Note: 05/04/2023 Preferred Route changed to Designated Router for UI's only
    {
        path: '/preferredRoute',
        component: PreferredRoute,
        title: 'Designated Route'
    },
    {
        path: '/driverPortal',
        component: () => (window.location = `${process.env.REACT_APP_DRIVER_PORTAL_PATH}`),
        title: 'DTI Portal'
    },
    {
        path: '/load-confirmation',
        component: LoadConfirmation,
        title: 'Loads'
    },
    {
        path: '/demo-load',
        component: DemoLoad,
        title: 'Demo Load',
        parentPath: '/load-confirmation'
    },
    {
        path: '/fuel-plan',
        component: FuelPlan,
        title: 'Fuel Plan',
        parentPath: '/load-confirmation'
    },
    {
        path: '/stop-details',
        component: StopDetails,
        title: 'Stop Details',
        parentPath: '/load-confirmation'
    },
    {
        path: '/reconcile',
        component: Reconcile,
        title: 'Reconcile Accuracy'
    },
    {
        path: '/logout',
        component: Logout,
        title: 'Logout'
    },
    {
        path: '/expenseapproval',
        component: ExpenseApproval,
        title: 'Expenses'
    },
    {
        path:'/createexpense',
        component:CreateExpense,
        title:'Create Expense'
    },
    {
        path: '/test-push-notifications',
        component: TestPushNotifications,
        title: 'Push Test'
    }
];

export default routes.map((route) => {
    return {
        ...route,
        component: withNavigationWatcher(route.component),
    };
});

